import adbsMap from "./ad_bs_map";

const bsValues = Object.values(adbsMap);
export const BSToAD = (date: string): string => {
  const bsKey = date;
  const indexOfBS = bsValues.indexOf(bsKey);
  if (indexOfBS === -1) {
    throw new Error("Invalid BS date.");
  }
  const adKey = Object.keys(adbsMap)[indexOfBS];
  return adKey;
};

export const ADToBS = (date: Date | string): string => {
  const adKey = date instanceof Date ? date.toISOString().split("T")[0] : date;
  const bsKey = adbsMap[adKey as keyof typeof adbsMap];
  if (!bsKey) {
    throw new Error("Invalid AD date.");
  }
  return bsKey;
};
